<style>
.form-control:disabled,
.form-control[readonly] {
  background-color: white !important
}
</style>
<template>
  <div>
    <div class="row animated fadeIn">
      <div class="col-md-8 offset-md-2">
        <div class="card ">
          <div class="card-header">
            <router-link :to="'/beast/decisions'">
              <button type="button" class="btn btn-sm btn-secondary" style="margin-right:12px">
                <i class="fa fa-arrow-left"></i>
              </button>
            </router-link>
            <strong>Versões da decision</strong>
            <div class="pull-right">
              <button :disabled="orderedItems.length > 0 && !(orderedItems[0].status == 'published' || orderedItems[0].status == 'failed' || orderedItems.length == 0)" type="button" class="btn btn-sm btn-secondary" @click.prevent="showNewVersionModal">
                <i class="fa fa-save"></i> Nova Versão</button>
              <button type="button" class="btn btn-sm btn-secondary" @click="loadVersions">
                <i class="fa fa-refresh"></i>
              </button>
            </div>

          </div>
          <div class="card-block">
            <table class="table table-bordered table-condensed condensed">
              <thead class="thead-inverse">
                <tr>
                  <th>Mensagem</th>
                  <th>Data Atualização</th>
                  <th>Agendamento</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, rowIndex) in orderedItems" :key="row.id">
                  <td>
                    {{ row.message }}
                  </td>
                  <td>{{row.updatedAt | formatDate}}</td>
                  <td align="center">
                    <span v-show="row.scheduledDate != undefined">{{row.scheduledDate | formatDate}}</span>
                    <span v-show="row.scheduledDate == undefined">-</span>
                  </td>
                  <td>{{row.status}}</td>
                  <td align="center">

                    <button title="Agendar publicação" v-show="row.status == 'uploaded'" type="button" class="btn btn-success" @click="showScheduleModal(row)">
                      <i class="fa fa-clock-o"></i>
                    </button>
                    <button title="Publicar agora" v-show="row.status == 'uploaded'" type="button" class="btn btn-success" @click="showPublishModal(row)">
                      <i class="fa fa-play"></i>
                    </button>
                    <button title="Copiar versão" v-show="row.status == 'published' && (orderedItems.length > 0 && (orderedItems[0].status == 'published' || orderedItems[0].status == 'failed'))" type="button" class="btn btn-success" @click="showCopyVersionModal(row)">
                      <i class="fa fa-undo"></i>
                    </button>
                    <button title="Remover versão" v-show="row.status == 'uploaded'" type="button" class="btn btn-danger" @click="showDeleteModal(row)">
                      <i class="fa fa-trash"></i>
                    </button>
                    <button title="Cancelar Agendamento" v-show="row.status == 'scheduled'" type="button" class="btn btn-danger" @click="showCancelScheduleModal(row)">
                      <i class="fa fa-close"></i>
                    </button>
                    <router-link :to="decisionId + '/' + row.id">
                      <button title="Visualizar Decision" type="button" class="btn btn-primary">
                        <i class="fa fa-eye"></i>
                      </button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--Modal de nova versão -->
    <modal title="Modal title" class="modal" v-model="newVersionModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Nova Versão</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        <form>
          <div class="form-group">
            <label lass="col-form-label">Extensão do arquivo</label>
            <select name="file.extension" v-model="fileExtension" class="form-control">
              <option value="dmn">DMN</option>
              <option value="xlsx">XLSX</option>
            </select>
          </div>
          <div class="form-group">
            <label class="col-form-label">Carregar novo dmn: </label>
            <input  :accept="'.' + fileExtension" id="newDmnFile" type="file" class="form-control" @change="onFileChange">
          </div>

          <div class="form-group">
            <label class="col-form-label">Mensagem</label>
            <input type="text" class="form-control" maxlength="50" name="message" v-validate="'required'" v-model="newVersion.message"  v-on:keypress.enter.prevent>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="newVersionModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-primary" :disabled="newVersion.message == '' || file == undefined" @click.prevent="upload">Salvar</button>
      </div>
    </modal>

    <!--Modal de delete -->
    <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Excluir Versão</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">Deseja excluir a versão
        <strong>{{ deleteVersion.message }}</strong>?
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteItem">Confirmar</button>
      </div>
    </modal>

    <!--Modal de copia de versao -->
    <modal title="Modal title" class="modal" v-model="copyVersionModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Copiar versão</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        Deseja copiar a versão?
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="copyVersionModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-primary" @click.prevent="copyItem">Confirmar</button>
      </div>
    </modal>

    <!--Modal de publicacao -->
    <modal title="Modal title" class="modal" v-model="publishModal" @ok="publishModal = false" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Publicar Versão</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">Deseja publicar a versão
        <strong>{{ publishVersion.message }}</strong>?
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="publishModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-primary" @click.prevent="publishItem">Confirmar</button>
      </div>
    </modal>

    <!--Modal de agendamento -->
    <modal title="Modal title" class="modal" v-model="scheduleModal" @ok="scheduleModal = false" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Agendar Publicação</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="row">
          <div class="col-md-5">
            Data
          </div>
          <div class="col-md-3">
            Hora
          </div>
          <div class="col-md-3">
            Minuto
          </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <datepicker :bootstrapStyling="true" :format="customFormatter" v-model="selectedDate" name="selectedDateUnique"></datepicker>
          </div>
          <div class="col-md-3">
            <select class="form-control input-sm" v-model="selectedHour">
              <option v-for="(row, rowIndex) in hoursToSelect" :key="row" :value="row">{{row}}</option>
            </select>
          </div>
          <div class="col-md-3">
            <select class="form-control input-sm" v-model="selectedMinutes">
              <option v-for="(row, rowIndex) in minutesToSelect" :key="row" :value="row">{{row}}</option>
            </select>
          </div>
        </div>
        <br>
        <div class="alert alert-info" role="alert" style="font-size:12px">
          Agendamento previsto para:
          <b>{{selectedDate | formatDate('DD/MM/YYYY')}}</b> às
          <b>{{selectedHour}}</b> hora(s) e
          <b>{{selectedMinutes}} </b> minuto(s)
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="scheduleModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-primary" @click.prevent="scheduleItem">Agendar</button>
      </div>
    </modal>

    <!--Modal de cancelamento agendamento -->
    <modal title="Modal title" class="modal" v-model="cancelScheduleModal" @ok="cancelScheduleModal = false" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <span class="modal-title">
          <strong>Cancelar agendamento</strong>
        </span>
      </div>
      <div slot="modal-body" class="modal-body">
        Deseja cancelar o agendamento?
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" @click="cancelScheduleModal = false">Cancelar</button>
        <button type="button" class="btn btn-sm btn-danger" @click.prevent="cancelScheduleItem">Confirmar</button>
      </div>
    </modal>
  </div>
</template>
<script>

// import axios from 'axios'
import axios from 'axios'
import modal from 'vue-strap/src/Modal'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'user',
  components: {
    modal, Datepicker
  },
  data() {
    return {
      newVersion: {
        message: ''
      },
      versions: [],
      decisionId: '',
      file: undefined,
      fileExtension: 'dmn',
      deleteVersion: {},
      copyVersion: {},
      publishVersion: {},
      scheduleVersion: {},
      cancelScheduleVersion: {},
      newVersionModal: false,
      deleteModal: false,
      scheduleModal: false,
      cancelScheduleModal: false,
      publishModal: false,
      copyVersionModal: false,
      hoursToSelect: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      selectedHour: '00',
      minutesToSelect: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
      selectedMinutes: '00',
      selectedDate: new Date()
    }
  },
  created() {
    this.loadVersions()
    this.decisionId = this.$route.params.id
  },
  mounted: function() {
  },
  computed: {
    orderedItems: function() {
      return this.versions.sort((a, b) => {
        return Date.parse(b.updatedAt) - Date.parse(a.updatedAt)
      })
    }
  },
  methods: {
    customFormatter(date) {
      return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear()
    },
    onFileChange: function(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.file = undefined
      } else {
        this.file = files[0]
      }
    },
    upload: function() {
      var id = this.$route.params.id
      const data = new FormData()
      data.append('file', this.file)
      data.append('message', this.newVersion.message)
      data.append('type', this.fileExtension)
      axios.post(`${process.env.BEAST_MANAGER_API_URL}decisions/${id}/versions`, data)
        .then(response => {
          this.showSuccess('Versão da Decision salva com sucesso')
          this.loadVersions()
          this.newVersion = {}
          this.newVersionModal = false
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao fazer o upload da decision.')
        })
    },
    loadVersions() {
      this.versions = []
      var id = this.$route.params.id
      if (id !== undefined) {
        axios.get(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions').then(response => {
          this.versions = response.data.results
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar as versões da decision.')
        })
      }
    },
    deleteItem() {
      this.deleteModal = false
      var id = this.$route.params.id
      axios.delete(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions/' + this.deleteVersion.id).then(response => {
        this.showSuccess('Versão excluida com sucesso!')
        this.loadVersions()
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao excluir a versão.')
      })
    },
    copyItem() {
      var id = this.$route.params.id
      axios.post(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions/' + this.copyVersion.id + '/copy').then(response => {
        this.showSuccess('Versão copiada com sucesso!')
        this.loadVersions()
        this.copyVersionModal = false
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao copiar a versão.')
      })
    },
    scheduleItem() {
      this.selectedDate.setMinutes(this.selectedMinutes)
      this.selectedDate.setHours(this.selectedHour)
      var json = {
        'status': 'scheduled',
        'scheduledDate': this.buildScheduleDate(this.selectedDate)
      }
      var id = this.$route.params.id
      axios.put(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions/' + this.scheduleVersion.id, json).then(response => {
        this.showSuccess('Versão agendada com sucesso!')
        this.loadVersions()
        this.scheduleModal = false
        this.scheduleVersion = {}
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao agendar a publicação da versão.')
      })
    },
    cancelScheduleItem() {
      var json = {
        'status': 'uploaded'
      }
      var id = this.$route.params.id
      axios.put(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions/' + this.cancelScheduleVersion.id, json).then(response => {
        this.showSuccess('Cancelamento com sucesso!')
        this.loadVersions()
        this.cancelScheduleModal = false
        this.cancelScheduleVersion = {}
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao agendar a publicação da versão.')
      })
    },
    publishItem() {
      var json = {
        'status': 'publishing'
      }
      var id = this.$route.params.id
      axios.put(process.env.BEAST_MANAGER_API_URL + 'decisions/' + id + '/versions/' + this.publishVersion.id, json).then(response => {
        this.showSuccess('Versão publicada com sucesso!')
        this.loadVersions()
        this.publishModal = false
        this.publishVersion = {}
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao publicar a versão.')
      })
    },
    showNewVersionModal() {
      this.newVersionModal = true
      this.file = undefined
      this.newVersion = {}
      document.getElementById('newDmnFile').value = ''
    },
    showPublishModal(item) {
      this.publishVersion = item
      this.publishModal = true
    },
    showCopyVersionModal(item) {
      this.copyVersion = item
      this.copyVersionModal = true
    },
    showDeleteModal(item) {
      this.deleteVersion = item
      this.deleteModal = true
    },
    showScheduleModal(item) {
      this.scheduleVersion = item
      this.scheduleModal = true
    },
    showCancelScheduleModal(item) {
      this.cancelScheduleVersion = item
      this.cancelScheduleModal = true
    },
    buildScheduleDate(date) {
      return date.getFullYear() + '-' + this.formatTwoDigits(date.getMonth() + 1) + '-' + this.formatTwoDigits(date.getDate()) + 'T' + this.formatTwoDigits(date.getHours()) + ':' + this.formatTwoDigits(date.getMinutes()) + ':' + '00' + '.' + this.formatThreeDigits(date.getMilliseconds()) + 'Z'
    },
    formatTwoDigits(number) {
      return ('0' + number).slice(-2)
    },
    formatThreeDigits(number) {
      return ('00' + number).slice(-3)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Versions.vue?75abcdb5